"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var options_1 = require("../options");
var full_jitter_1 = require("./full/full.jitter");
var no_jitter_1 = require("./no/no.jitter");
function JitterFactory(options) {
    switch (options.jitter) {
        case options_1.JitterTypes.Full:
            return full_jitter_1.fullJitter;
        case options_1.JitterTypes.None:
        default:
            return no_jitter_1.noJitter;
    }
}
exports.JitterFactory = JitterFactory;
//# sourceMappingURL=jitter.factory.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/exponential-backoff/dist/jitter/jitter.factory.js
// module id = 310
// module chunks = 86 87